import {Component,OnInit,ViewChild,ElementRef, OnDestroy, AfterViewInit} from '@angular/core';
import {AppComponent} from './app.component';
declare var jQuery: any;

@Component({
    selector: 'app-rightpanel',
    templateUrl: './app.rightpanel.component.html',
    // template: `
    //     <div class="layout-rightpanel" [ngClass]="{'layout-rightpanel-active': app.rightPanelActive}" (click)="app.onRightPanelClick()">
    //         <div #rightPanelMenuScroller class="nano">
    //             <div class="nano-content right-panel-scroll-content">
                    
    //                 <div class="layout-rightpanel-header">
    //                     <div class="weather-day">Wednesday</div>
    //                     <div class="weather-date">Jan 26</div>
    //                 </div>

    //                 <div class="layout-rightpanel-content">
    //                     <h1>Status de Máquinas</h1>
    //                     <h2>Tempo Real</h2>

    //                     <!--<div class="weather-today">
    //                         <span class="weather-today-value">21&#8451;</span>
    //                         <img src="assets/layout/images/dashboard/weather-icon-2.svg" width="60"/>
    //                     </div>-->

    //                     <ul class="weekly-weather">
    //                         <li>
    //                             Rotativa 12 EST
    //                             <!--<img src="assets/layout/images/dashboard/weather-icon-1.svg"/>
    //                             <span class="weekly-weather-value">24</span>-->
    //                         </li>
    //                         <li>
    //                             Rotativa 20 EST
    //                             <!--<img src="assets/layout/images/dashboard/weather-icon-1.svg"/>
    //                             <span class="weekly-weather-value">24</span>-->
    //                         </li>
    //                         <li>
    //                             Rotativa 12 EST
    //                             <!--<img src="assets/layout/images/dashboard/weather-icon-1.svg"/>-->
    //                             <span>PRODUZINDO</span>
    //                         </li>
    //                     </ul>
    //                 </div>
    //             </div>
    //         </div>
            
    //     </div>
    // `
})
export class AppRightPanel implements OnInit, AfterViewInit, OnDestroy {

    rightPanelMenuScroller: HTMLDivElement;
    
    @ViewChild('rightPanelMenuScroller') rightPanelMenuScrollerViewChild: ElementRef;

    now = new Date();
    private nowUpdateInterval: any;

    constructor(public app: AppComponent) {}

    ngOnInit() {
        this.nowUpdateInterval = setInterval(() => {
            this.now = new Date();
        }, 600000);
    }
    
    ngAfterViewInit() {
        this.rightPanelMenuScroller = <HTMLDivElement> this.rightPanelMenuScrollerViewChild.nativeElement;
        
        setTimeout(() => {
            jQuery(this.rightPanelMenuScroller).nanoScroller({flash:true});
        }, 10);
    }
    
    ngOnDestroy() {
        clearInterval(this.nowUpdateInterval);
        jQuery(this.rightPanelMenuScroller).nanoScroller({flash:true});
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/app.rightpanel.component.ts